import { render } from "./Banner.vue?vue&type=template&id=2093fb59&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=2093fb59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2093fb59"]])

export default __exports__